import { SVGInterface } from "../../interface";

const InProgressTracker = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M8.16667 0.708984C6.49333 0.875651 4.96482 1.5406 3.72982 2.55143L4.91797 3.73958C5.83964 3.02292 6.95167 2.5428 8.16667 2.3903V0.708984ZM9.83333 0.708984V2.39193C13.1167 2.80443 15.6667 5.60829 15.6667 9.00163C15.6667 12.395 13.1167 15.1972 9.83333 15.6097V17.2926C14.0383 16.8726 17.3333 13.315 17.3333 9.00163C17.3333 4.68829 14.0383 1.12815 9.83333 0.708984ZM2.55143 3.72982C1.53977 4.96482 0.875651 6.49333 0.708984 8.16667H2.3903C2.5428 6.95167 3.02292 5.83964 3.73958 4.91797L2.55143 3.72982ZM12.5775 5.91081L8.16667 10.3216L6.25586 8.41081L5.07747 9.58919L8.16667 12.6784L13.7559 7.08919L12.5775 5.91081ZM0.708984 9.83171C0.875651 11.5059 1.53977 13.0352 2.55143 14.2702L3.74121 13.0804C3.02454 12.1587 2.54443 11.0467 2.39193 9.83171H0.708984ZM4.91797 14.2604L3.72982 15.4486C4.96482 16.4594 6.49171 17.1243 8.16504 17.291V15.6097C6.95066 15.457 5.83923 14.9768 4.91797 14.2604Z"
      fill={color || "black"}
    />
  </svg>
);

export default InProgressTracker;
